import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "previous",
  "use": "previous-usage",
  "viewBox": "0 0 9 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 14\" id=\"previous\"><path d=\"M8.414 1.707L7 .293.293 7 7 13.707l1.414-1.414-5.292-5.294z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol